export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            沟通入口
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            有影片推荐、问题反馈或合作建议？欢迎与我们取得联系
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          <div className="rounded-2xl bg-background-50 p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <div className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</div>
                <div className="text-xs text-foreground-500">contact@6080ys.com</div>
              </div>
              <div className="text-center">
                <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-wechat-line text-lg"></i>
                </span>
                <div className="text-sm font-semibold text-foreground-800 mb-1">微信客服</div>
                <div className="text-xs text-foreground-500">6080movie_kf</div>
              </div>
              <div className="text-center">
                <span className="w-11 h-11 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mx-auto mb-3">
                  <i className="ri-message-3-line text-lg"></i>
                </span>
                <div className="text-sm font-semibold text-foreground-800 mb-1">在线反馈</div>
                <div className="text-xs text-foreground-500">工作日24h内回复</div>
              </div>
            </div>

            <div className="text-center pt-6 border-t border-background-200">
              <p className="text-sm text-foreground-500 mb-4">
                欢迎向我们推荐你想看的影片，我们会尽快安排上架
              </p>
              <a
                href="mailto:contact@6080ys.com"
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
              >
                <i className="ri-send-plane-line text-base"></i>
                发送邮件
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}